module.exports = __webpack_public_path__ + "images/emoji/notebook.ffa2c2210ee788b502dd.png";